module.exports = __webpack_public_path__ + "img/uploadexample.ea383dcb.png";